module.exports = __webpack_public_path__ + "static/media/about_me.d5bf1100.svg";